/* eslint-disable max-len */
import useTranslation from '../../../hooks/useTranslations';
import ModalWrapper from '../layouts/partials/ModalWrapper';

const MediaEmbedModal = ({
	isModalOpen, setIsModalOpen, fileUrl = null, fileType,
}) => {
	const t = useTranslation();

	const closeModal = () => {
		setIsModalOpen(false);
	};

	const getTagByFileType = (type, url) => {
		if (type === 'pdf') {
			return <iframe style={{ height: '100%', width: '100%' }} src={`${process.env.PUBLIC_URL}/pdfviewer/web/viewer.html?file=${encodeURIComponent(url)}`} title="pdfviewer" />;
		}

		if (type === 'image') {
			return <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={url} alt="images" />;
		}

		if (type === 'video') {
			return (
				// eslint-disable-next-line jsx-a11y/media-has-caption
				<video style={{ maxWidth: '100%', maxHeight: '100%' }} controls>
					<source src={url} />
				</video>
			);
		}

		return null;
	};

	return (
		<ModalWrapper isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} maxWidth="max-w-full" fullSize showCloseIcon>
			<div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
				<div className="pt-6 flex items-center justify-center" style={{ flexGrow: 1 }}>
					{ getTagByFileType(fileType, fileUrl) }
				</div>

				<div className="flex -mx-6 border-t divide-x border-oly-gray-lightest divide-oly-gray-lightest">
					<button
						type="button"
						className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-normal text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
						onClick={closeModal}
					>
						{t('general_close')}
					</button>
				</div>
			</div>
		</ModalWrapper>
	);
};

export default MediaEmbedModal;
